import { createIconSet } from '@expo/vector-icons';
// original file
// node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/glyphmaps/MaterialCommunityIcons.json
import glyphMap from '~/../assets/fonts/MaterialCommunityIcons/unicodesMap.json';
// original ttf file
// node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf
export default createIconSet(
    glyphMap,
    'MaterialCommunityIcons',
    require('~/../assets/fonts/MaterialCommunityIcons/MaterialCommunityIcons.ttf')
);
